import React from "react";
import { Link } from "../../../../packages/router/Link.js";

type Props = {
  entryId: string;
};

/**
 * Renders the entry copy link.
 */
export const CopyLink = ({ entryId }: Props) => {
  return (
    <Link to={`/copy/${entryId}`} className="button print-none">
      Kopeeri
    </Link>
  );
};
